export default {"src":"/_next/static/media/enerflo-platform-icon-industry-leading-technology.54b2ce28.svg","height":160,"width":160};